export default __webpack_public_path__ + "static/media/filtro.7bd3964c.jpg";